module.exports = __webpack_public_path__ + "static/media/telefono_parques.68eef107.svg";